<div class="modal-content">

    <div class="modal-header border-0">
        <h2 class="modal-title mb-0">Atención</h2>
        <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.close({estado:false})"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-12"><p>{{data.alerta}}</p></div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12 justify-content-center text-center">
                <button (click)="aceptar()" class="btn btn-sm btn-primary mx-1">
                    Aceptar
                </button>
            </div>
        </div>
    </div>

</div>
